import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
const API_BASE_URL = 'http://localhost:8000';
const OAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const access_token = searchParams.get('access_token');
        if (access_token) {
          console.log('Received access token directly:', access_token);
          localStorage.setItem('access_token', access_token);
          
          navigate('/');
          return;
        }
        
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        
        if (!code || !state) {
          throw new Error('Authorization failed: missing required parameters');
        }
        console.log('code', code, 'state', state);

        const response = await fetch(`${API_BASE_URL}/auth/google/callback?code=${code}&state=${state}`);
        
        if (!response.ok) {
          throw new Error('OAuth callback processing failed');
        }

        const data = await response.json();
        
        localStorage.setItem('access_token', data.access_token);
        
        navigate('/');
      } catch (error) {
        console.error('OAuth callback processing error:', error);
        navigate('/login?error=oauth_callback_failed');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">正在处理登录...</h2>
        <p className="text-gray-600">请稍候，正在完成Google登录</p>
      </div>
    </div>
  );
};

export default OAuthCallback;  